import api from './index';
export default { get(applicationHashid) { const path = `/api/internal/application_states/${applicationHashid}`; return api({ method: 'get', url: path }).then(res => res?.trackingState); } };
